import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-base shadow-header flex flex-col gap-5 px-4 py-8 sm:gap-8 md:p-5',
    imageWrapper: 'relative aspect-38/20 w-full overflow-hidden max-md:hidden',
    image: 'rounded-[18px] object-cover',
    summaryList: 'flex flex-col gap-3',
    summaryRow: 'flex items-baseline gap-5',
    summaryLabel: 'heading-s min-w-0',
    summaryDots: 'border-tertiary flex-1 shrink-0 border-b border-dashed',
    summaryValue: 'heading-s-regular shrink-0',
    totalRow: 'mt-4 flex items-baseline justify-between gap-5 sm:mt-6',
    totalLabel: 'heading-m-regular',
    totalValue: 'heading-2xl shrink-0',
    payButtons: 'w-full',
    policy: 'heading-xs',
    policyLink: 'text-accent heading-xs-regular'
  }
});
